
import { call, put, take } from 'redux-saga/effects'
import URI from 'urijs';

import getPromiseCallback from '../utils/getPromiseCallback';

import { createActionTypes } from './common';

export const LOGIN_ACTION_TYPE = createActionTypes('auth/LOGIN');
export const LOGOUT_ACTION_TYPE = createActionTypes('auth/LOGOUT');

const LOCAL_STORAGE_KEY_TOKEN = 'auth_token';

function* getToken() {
    let token = (window && window.location) ? getTokenWindowLocation() : null;
    if (!token) {
        token = yield call([localStorage, 'getItem'], LOCAL_STORAGE_KEY_TOKEN);
        if (token) {
            console.log('Token from localStorage:', token);
        }
    }
    return token;
}

function getTokenWindowLocation() {
    let uri = new URI(window.location.href);
    let token = uri.search(true).token;
    if (token) {
        console.log('Token from URL:', token);
        uri.removeSearch('token');
        window.history.pushState('', '', uri.toString());
    }
    return token;
}

function login(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'auth',
            name: 'login',
            body: {
                projectId: action.projectId,
                user: {
                    username: action.username,
                    password: action.password
                }
            },
            callback: getPromiseCallback(resolve, reject)
        });
    });
}

function logout(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'auth',
            name: 'logout',
            token: action.token,
            callback: getPromiseCallback(resolve, reject)
        });
    });
}

function verify(serverApi, token) {
    return new Promise((resolve, reject) => {
        serverApi.callGet({
            module: 'auth',
            name: 'verify',
            token: token,
            callback: getPromiseCallback(resolve, reject)
        });
    });
}

export function* authFlow(options) {
    if (options && (options.anonymous === true)) {
        console.log('anonymous, auth flow is disabled');
        return;
    }
    let token = yield call(getToken);
    while (true) {
        try {
            let authData = null;
            if (token) {
                yield put({type: LOGIN_ACTION_TYPE.DEFAULT});
                authData = yield call(verify, options.serverApi, token);
            } else {
                const loginAction = yield take(LOGIN_ACTION_TYPE.DEFAULT)
                authData = yield call(login, options.serverApi, loginAction);
            }
            yield call([localStorage, 'setItem'], LOCAL_STORAGE_KEY_TOKEN, authData.user.token);
            yield put({type: LOGIN_ACTION_TYPE.SUCCESS, data: authData});

            const logoutAction = yield take(LOGOUT_ACTION_TYPE.DEFAULT)
            try {
                const data = yield call(logout, options.serverApi, logoutAction);
                yield call([localStorage, 'removeItem'], LOCAL_STORAGE_KEY_TOKEN);
                yield put({type: LOGOUT_ACTION_TYPE.SUCCESS, data: data});

                let afterLogoutUrl = logoutAction.logoutUrl || options.afterLogoutUrl;
                if (options && options.history && afterLogoutUrl) {
                    if (afterLogoutUrl.indexOf('#') !== -1) {
                        yield call([window.location, 'assign'], afterLogoutUrl);
                    } else {
                        if (options.history.push) {
                            yield call(options.history.push, afterLogoutUrl);
                        }
                    }
                }
            } catch (error) {
                yield put({type: LOGOUT_ACTION_TYPE.FAILED, error});
            }

        } catch (error) {
            yield put({type: LOGIN_ACTION_TYPE.FAILED, error});
        }

        token = null;
    }
}
